import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import "../styles.css";

export default function About() {
  return (
    <>
      <SEO
        title="About ZeMaxi"
        description="Learn about ZeMaxi - a passionate Twitch streamer and developer creating free streaming tools for content creators. Discover my story, skills in OBS Studio, Streamer.bot, JavaScript, and C#."
        keywords="ZeMaxi about, streamer bio, content creator, OBS developer, Streamer.bot creator, gaming streamer, streaming tools developer"
        url="https://zemaxi.com/about"
      />
      <Navbar />
      <main>
        <section className="about-hero noise-bg">
          <div className="container">
            <h1>About <span className="highlight">Zemaxi</span></h1>
            <p>Streamer, Noob Gamer and Creative Tool Creator</p>
          </div>
        </section>
        <section className="about-section">
          <div className="container">
            <div className="about-content">
              <div className="about-bio">
                <div className="about-image">
                  <img src="/images/zemaxi-profile.jpg" alt="Zemaxi" />
                </div>
                <div className="about-text">
                  <h2>My <span className="highlight">Story</span></h2>
                  <p>Hi there! I'm ZeMaxi (Or just Maxi), a passionate streamer and developer with a love for gaming and creating tools that help other content creators shine. My journey began 5 years ago when I started streaming my gaming sessions just for fun, but quickly developed into something much more meaningful.</p>
                  <p>What sets me apart is my dual passion for both entertainment and technical development. When I'm not live on Twitch playing the latest games or chatting with the amazing community, I'm coding away, creating hopefully useful tools for other streamers...or I could just be working my normal job lol.</p>
                  <p>My mission is to build a creative space where gaming, technology, and community converge. Whether you're here for the gameplay, the laughs, or the tools that can elevate your own stream - welcome to my digital hub!</p>
                </div>
              </div>
              <div className="skills">
                <h2>Technical <span className="highlight">Skills</span></h2>
                <p>Over the years, I've developed expertise in various streaming technologies and development tools:</p>
                <div className="skill-list">
                  <div className="skill-tag"><i className="fas fa-video"></i> OBS Studio</div>
                  <div className="skill-tag"><i className="fas fa-robot"></i> Streamer.bot</div>
                  <div className="skill-tag"><i className="fas fa-code"></i> JavaScript</div>
                  <div className="skill-tag"><i className="fas fa-code"></i> C#</div>
                  <div className="skill-tag"><i className="fas fa-paint-brush"></i> CSS & Animation</div>
                  <div className="skill-tag"><i className="fas fa-file-image"></i> Adobe Photoshop</div>
                  <div className="skill-tag"><i className="fas fa-file-video"></i> Video Editing</div>
                  <div className="skill-tag"><i className="fas fa-server"></i> API Integration</div>
                </div>
              </div>
              {/* Timeline/journey section can be added here if needed */}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
